export default __webpack_public_path__ + "static/media/cloud-tech-bg-1.4b35bab2.jpg";